exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mdc-list-item__primary-text {\n  margin-bottom: 0;\n}\n.mdc-list-item__primary-text--scrollable {\n  overflow: auto;\n}\n.config-delete {\n  margin-left: 15px;\n}\n.config-tf {\n  border-radius: 0;\n  width: 50%;\n}", ""]);

// exports
